import { createContext, useContext, type ReactNode } from 'react'

const LEGACY_BASE = '/layout-generator'
const V2_BASE = '/layout-generator-v2'

function navigation(basePath: string) {
  return {
    basePath,
    isV2: basePath === V2_BASE,
    href: (suffix = '') => `${basePath}${suffix && !suffix.startsWith('/') ? '/' : ''}${suffix}`,
  }
}

// Embedded workspaces and existing routes retain their original navigation.
const legacyNavigation = navigation(LEGACY_BASE)
const v2Navigation = navigation(V2_BASE)
const LayoutGeneratorNavigation = createContext(legacyNavigation)

export function LayoutGeneratorV2Scope({ children }: { children: ReactNode }) {
  return <LayoutGeneratorNavigation.Provider value={v2Navigation}>{children}</LayoutGeneratorNavigation.Provider>
}

export function useLayoutGeneratorNavigation() {
  return useContext(LayoutGeneratorNavigation)
}
